export default __webpack_public_path__ + "static/media/masterbed2.85d3c677.jpg";